/**
 * Kratome — Predictive Search
 * Uses Shopify's built-in /search/suggest.json endpoint. Plain fetch,
 * no external service. Debounced to avoid unnecessary requests.
 */
(function () {
  "use strict";

  var modal = document.querySelector("[data-search-modal]");
  var input = document.querySelector("[data-search-input]");
  var results = document.querySelector("[data-search-results]");
  var openBtns = document.querySelectorAll("[data-search-open]");
  var closeBtn = document.querySelector("[data-search-close]");
  var backdrop = modal ? modal.querySelector(".search-modal__backdrop") : null;
  var debounceTimer = null;

  function open() {
    if (!modal) return;
    modal.dataset.open = "true";
    document.body.style.overflow = "hidden";
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function close() {
    if (!modal) return;
    modal.dataset.open = "false";
    document.body.style.overflow = "";
  }

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || "en", {
      style: "currency",
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR",
    });
  }

  function renderResults(data, term) {
    if (!results) return;
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    if (!term) {
      results.innerHTML = "";
      return;
    }
    if (products.length === 0) {
      results.innerHTML = '<p class="search-modal__empty">No results for "' + term + '".</p>';
      return;
    }
    var html = "";
    products.forEach(function (product) {
      html +=
        '<a href="' + product.url + '" class="search-modal__result">' +
        '<div class="search-modal__result-image">' + (product.image ? '<img src="' + product.image + '" alt="" loading="lazy" width="56" height="56">' : "") + "</div>" +
        '<div><p class="search-modal__result-title">' + product.title + "</p>" +
        '<p class="search-modal__result-price">' + money(product.price) + "</p></div>" +
        "</a>";
    });
    html += '<a href="' + document.querySelector("[data-search-input]").closest("form").action + "?q=" + encodeURIComponent(term) + '" class="search-modal__view-all">View all results for "' + term + '" →</a>';
    results.innerHTML = html;
  }

  function search(term) {
    if (!term) {
      renderResults({}, "");
      return;
    }
    fetch("/search/suggest.json?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title")
      .then(function (r) { return r.json(); })
      .then(function (data) { renderResults(data, term); })
      .catch(function () {});
  }

  function init() {
    openBtns.forEach(function (btn) { btn.addEventListener("click", open); });
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (backdrop) backdrop.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
    if (input) {
      input.addEventListener("input", function () {
        clearTimeout(debounceTimer);
        var term = input.value.trim();
        debounceTimer = setTimeout(function () { search(term); }, 250);
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
